import React from 'react';
import { CampaignsPageView } from '@/domains/campaigns';

const CampaignKanban: React.FC = () => {
  return <CampaignsPageView />;
};

export default CampaignKanban;
